module.exports = __webpack_public_path__ + "img/img3.9023564d.svg";